import '@videojs/html/video/player';
import '@videojs/html/video/minimal-skin';

import MicroModal from 'micromodal';  // es6 module

document.addEventListener('DOMContentLoaded', () => {
    const modalCallbacks = {
        onShow: (modal) => {
            const videoEl = modal.querySelector('.modal__container video');
            if (videoEl) {
                videoEl.play();
            }
        },
        onClose: (modal) => {
            const videoEl = modal.querySelector('.modal__container video');
            if (videoEl) {
                videoEl.pause();
            }
        }
    };

    MicroModal.init(modalCallbacks);

    // Listen for clicks on links that point to a modal ID
    document.querySelectorAll('.events__play-button').forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            // Pass callbacks directly to avoid config being overwritten by other init() calls.
            MicroModal.show('modal-event-video', modalCallbacks);
        });
    });
});